export function StreakFooter() {
  return (
    <div className="mt-4 text-sm md:text-base">
      Keep the streak going tomorrow!
    </div>
  );
}
